import React from "react";
import AnnouncementBar from "../../../../components/AnnouncementBar/AnnouncementBar";
import CustomerReportIndex from "../../../../components/SidetabPages/Report/Customers/CustomerReportIndex";

const CustomerReport = () => {
  return (
    <>
      <AnnouncementBar />
      <CustomerReportIndex />
    </>
  );
};
export default CustomerReport;
